<template lang="pug">
.cp-customer
  .top-wrap
    top-title(topType="customer", @showModal="showModal")
    .logos-wrap
      .w
        server-list.server-list
  .page2
    cooperation
    success-system
    successTeam
  //- success-case
  logo-wall(@showModal="showModal")
</template>
<script>
import serverList from './components/server-list'
import cooperation from './components/cooperation'
import successSystem from './components/success-system'
import successTeam from './components/success-team'
// import successCase from './components/success-case'
import logoWall from './components/logo-wall'

export default {
  components: {
    serverList,
    cooperation,
    successSystem,
    successTeam,
    // successCase,
    logoWall
  },
  props: {},
  data () {
    return {}
  },
  computed: {},
  methods: {
    showModal (isShow) {
      this.$emit('showModal', isShow)
    }
  }
}
</script>
<style lang="stylus">
.cp-customer
  background rgba(15,25,57,1)
  .top-wrap
    position relative
    .logos-wrap
      width 100%
      height 172px
      background url('../../assets/logo-bar.jpg') center / 100% no-repeat
      position absolute
      bottom -50px
      .w
        position relative
        height 100%
      .server-list
        bottom -250px
        right 20px
        position absolute
        bottom 0px
        right 20px
  .page2
    background url('../../assets/customer-bg2.jpg') top / 100% no-repeat
</style>
